import { render, staticRenderFns } from "./CoachingDetails.vue?vue&type=template&id=1dfb8b35&scoped=true&"
import script from "./CoachingDetails.vue?vue&type=script&lang=js&"
export * from "./CoachingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb8b35",
  null
  
)

export default component.exports